// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import PageView from 'syft-acp-core/components/PageView'
import WorkersDetail from 'syft-acp-core/entities2/WorkersDetail'
import { WorkerSubNavigation } from './SubNavigation'

export const EntityWorkers2View = ({ match: { params } }) => (
  <>
    <WorkerSubNavigation workerID={params.id} />
    <PageView title={['Workers', `Viewing worker ${params.id}`]}>
      <WorkersDetail id={Number(params.id)} />
    </PageView>
  </>
)
